export enum EstimateStatus {
  DRAFT = 'draft',
  SENT = 'sent',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  EXPIRED = 'expired',
  CONVERTED = 'converted'
}

export interface EstimateItem {
  id?: string;
  variant_id: string;
  quantity: number;
  unit_price: number;
  discount_percent: number;
  description?: string;
  hsn_code?: string;
  // Calculated fields (for responses)
  discount_amount?: number;
  taxable_amount?: number;
  tax_rate?: number;
  cgst_amount?: number;
  sgst_amount?: number;
  igst_amount?: number;
  tax_amount?: number;
  line_total?: number;
  // Enriched fields
  product_name?: string;
  variant_name?: string;
  item_code?: string;
}

export interface EstimateBase {
  customer_id: string;
  estimate_date: string;
  valid_until: string;
  billing_address_id?: string;
  shipping_address_id?: string;
  notes?: string;
  terms_and_conditions?: string;
}

export interface EstimateCreate extends EstimateBase {
  items: EstimateItem[];
}

export interface EstimateUpdate extends Partial<EstimateBase> {
  items?: EstimateItem[];
}

export interface EstimateListItem {
  id: string;
  estimate_number: string;
  customer_id: string;
  customer_name: string;
  estimate_date: string;
  valid_until: string;
  status: EstimateStatus;
  total_amount: number;
  items_count: number;
  created_at: string;
}

export interface EstimateResponse extends EstimateBase {
  id: string;
  estimate_number: string;
  status: EstimateStatus;
  subtotal: number;
  discount_amount: number;
  tax_amount: number;
  total_amount: number;
  converted_to_order_id?: string;
  converted_at?: string;
  created_by_admin_id: string;
  updated_by_admin_id?: string;
  status_changed_at?: string;
  status_changed_by_admin_id?: string;
  created_at: string;
  updated_at?: string;
  items: EstimateItem[];
  // Enriched fields
  customer_name?: string;
  customer_email?: string;
  customer_mobile?: string;
  billing_address?: {
    id: string;
    address_line1: string;
    address_line2?: string;
    city: string;
    state: string;
    postal_code: string;
    country: string;
    contact_person?: string;
    contact_phone?: string;
    gstin?: string;
  };
  shipping_address?: {
    id: string;
    address_line1: string;
    address_line2?: string;
    city: string;
    state: string;
    postal_code: string;
    country: string;
    contact_person?: string;
    contact_phone?: string;
    gstin?: string;
  };
}

export interface EstimateListResponse {
  estimates: EstimateListItem[];
  total: number;
  page: number;
  per_page: number;
  total_pages: number;
  status_counts: Record<string, number>;
  total_value: number;
}

export interface EstimateSearchFilters {
  customer_id?: string;
  status?: EstimateStatus[];
  estimate_date_from?: string;
  estimate_date_to?: string;
  valid_until_from?: string;
  valid_until_to?: string;
  search_term?: string;
  created_by_admin_id?: string;
  amount_min?: number;
  amount_max?: number;
}

export interface EstimateStatusUpdate {
  status: EstimateStatus;
  notes?: string;
}

export interface EstimateSendRequest {
  send_via_email: boolean;
  send_via_sms: boolean;
  send_via_whatsapp: boolean;
  custom_message?: string;
}

export interface EstimateConversionRequest {
  order_date?: string;
  expected_delivery_date?: string;
  shipping_charges?: number;
  packing_charges?: number;
  other_charges?: Array<{
    name: string;
    amount: number;
    description?: string;
  }>;
  notes?: string;
  warehouse_id?: string;
}